import { render, staticRenderFns } from "./h3-textarea.vue?vue&type=template&id=5fd85d34&scoped=true"
import script from "./h3-textarea.vue?vue&type=script&lang=ts"
export * from "./h3-textarea.vue?vue&type=script&lang=ts"
import style0 from "./h3-textarea.vue?vue&type=style&index=0&id=5fd85d34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd85d34",
  null
  
)

export default component.exports